import React from 'react';

const MoreActive = (props) => (
  <svg viewBox="0 0 6.17 20.762" xmlns="http://www.w3.org/2000/svg" {...props}>
    <defs>
      <style>{`.moreIconClass{fill:none;stroke:currentColor;stroke-miterlimit:10;stroke-width:1px;}`}</style>
    </defs>
    <g transform="translate(0.375 0.375)">
      <path
        className="moreIconClass"
        transform="translate(-235.75 -413)"
        d="M238.46,418.42a2.71,2.71,0,1,0-2.71-2.71A2.71,2.71,0,0,0,238.46,418.42Z"
      />
      <path
        className="moreIconClass"
        transform="translate(-235.75 -414.454)"
        d="M238.46,427.17a2.71,2.71,0,1,0-2.71-2.71A2.71,2.71,0,0,0,238.46,427.17Z"
      />
      <path
        className="moreIconClass"
        transform="translate(-235.75 -415.908)"
        d="M238.46,435.92a2.71,2.71,0,1,0-2.71-2.71A2.71,2.71,0,0,0,238.46,435.92Z"
      />
    </g>
  </svg>
);

export default MoreActive;
